import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { LinksBar } from "../../LinksBar/LinksBar";
import { Text } from "../../Text/Text/Text";
import styles from "./CategoryMasthead.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CategoryMasthead = function CategoryMasthead(_ref) {
  var bodyText = _ref.bodyText,
    breadcrumbs = _ref.breadcrumbs,
    headline = _ref.headline,
    navigation = _ref.navigation;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [breadcrumbs && /*#__PURE__*/_jsx("div", {
        className: styles.breadcrumbs,
        children: /*#__PURE__*/_jsx(LinksBar, _objectSpread({}, breadcrumbs))
      }), /*#__PURE__*/_jsx(HeadingText, {
        align: "left",
        className: styles.headline,
        typog: "headline3",
        children: headline
      }), bodyText && /*#__PURE__*/_jsx(Text, {
        className: styles.body,
        typog: "bodycopyLarge",
        richText: true,
        children: bodyText
      }), navigation && /*#__PURE__*/_jsx(LinksBar, _objectSpread({}, navigation))]
    })
  });
};